// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tj9Q2b344yaLwAyQS8Wy{display:inline-block;fill:var(--fandom-text-color);height:17px;margin-right:7px;width:16px}.uQP23SdFpRHHK2wMpaO6{animation:none;height:auto}.SLK6HGfNhTiFqgYSSApV{background-color:rgba(0,0,0,0);border:none;border-bottom:1px solid var(--theme-link-color);color:var(--theme-link-color);font-family:rubik,helvetica,arial,sans-serif;font-size:16px;font-style:normal;font-weight:normal;height:36px;line-height:19px;outline:none;padding:0;width:90%}.GxNxueFkF_Y3C8zdT7yQ{border-bottom:1px solid #ee1a41}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconEnvelope": `tj9Q2b344yaLwAyQS8Wy`,
	"wrapper": `uQP23SdFpRHHK2wMpaO6`,
	"input": `SLK6HGfNhTiFqgYSSApV`,
	"inputError": `GxNxueFkF_Y3C8zdT7yQ`
};
export default ___CSS_LOADER_EXPORT___;
